exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modulemain[data-v-5e1aa834]{color:#666;grid-area:main}.modulemain__title[data-v-5e1aa834]{font-family:inherit;color:rgba(0,0,0,.85);font-size:40px;font-weight:700;line-height:120%;margin-top:-7px;margin-bottom:22px;text-transform:uppercase}.modulemain__announce[data-v-5e1aa834]{margin-bottom:27px;font-size:18px;line-height:1.25;word-break:break-word}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e1aa834","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/modules/modulemain/ModuleMain.vue
// module id = f192e5971d4ca80b6044
// module chunks = 0